// JKHive-flavored Compliance — reuses the admin-compliance page component
// inside the JKHive layout.
import React from 'react';
import AdminCompliance from '../admin-compliance';

const JKHiveCompliance = () => <AdminCompliance />;
export default JKHiveCompliance;
